import { isConfigReport, isJourneyReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { ConfigReportGetterStrategy } from '../../ConfigReportGetterStrategy';
import { RelationalReportGetterStrategy } from '../../RelationalReportGetterStrategy';
import { JourneyReportGetterStrategy } from '../../JourneyReportGetterStrategy';
const getReportGetterStrategyForReport = report => {
  if (isConfigReport(report)) {
    return ConfigReportGetterStrategy;
  }
  if (isRelationalReport(report)) {
    return RelationalReportGetterStrategy;
  }
  if (isJourneyReport(report)) {
    return JourneyReportGetterStrategy;
  }
  return null;
};
export const hasStandardFieldGetter = (report, fieldType) => {
  const getterStrategy = getReportGetterStrategyForReport(report);
  const getField = getterStrategy === null || getterStrategy === void 0 ? void 0 : getterStrategy[fieldType];
  return !!getField;
};
export const getStandardFieldType = (report, fieldType, fallback) => {
  const getterStrategy = getReportGetterStrategyForReport(report);
  const getField = getterStrategy === null || getterStrategy === void 0 ? void 0 : getterStrategy[fieldType];
  if (getField) {
    return getField(report);
  }
  if (fallback !== undefined) {
    return fallback;
  }
  throw new Error(`Error: report does not have a getter available for the ${fieldType} field. Report: ${report}`);
};